// Supported languages (4 only: en, fr, de, es)
import { SUPPORTED_LANGS } from "@/i18n/dictionaries";

export const HOMEPAGE_LANGS = SUPPORTED_LANGS;

// Flat keys (home page only)
export const HOMEPAGE_DICT = {
  en: {
    brand: "JOBolar.Ai",
    nav_how: "How it works",
    nav_features: "Features",
    nav_reviews: "Reviews",
    nav_pricings: "Pricings",
    nav_faq: "FAQ",
    nav_contact: "Contact Us",
    nav_login: "Log In",
    nav_signup: "Sign Up",
    hero_title_prefix: "Auto-apply to jobs with",
    hero_sub:
      "Connect your resume once. JOBolar finds roles locally and worldwide, auto-tailors your resume, generates customized AI cover letters, and applies for you—while you track everything in one dashboard.",
    cta_get_started: "Get started free",
    cta_see_how: "See how it works",
    trust_line: "Trusted by job seekers seeking roles both locally and worldwide.",
    dash_preview: "Dashboard Preview",
    jobs_applied: "Jobs Applied",
    today: "Today",
    this_week: "This week",
    bullet_1: "AI-tailored cover letters",
    bullet_2: "Auto-fill applications",
    bullet_3: "Track outcomes",
    bullet_4: "Platform compliance",
    footer_privacy: "Privacy",
    footer_terms: "Terms",
    rights: "All rights reserved.",
  },

  fr: {
    brand: "JOBolar.Ai",
    nav_how: "Fonctionnement",
    nav_features: "Fonctionnalités",
    nav_reviews: "Avis",
    nav_pricings: "Tarifs",
    nav_faq: "Questions fréquentes",
    nav_contact: "Contact",
    nav_login: "Connexion",
    nav_signup: "S’inscrire",
    hero_title_prefix: "Postulez automatiquement avec",
    hero_sub:
      "Connectez votre CV une fois. JOBolar trouve des postes localement et dans le monde entier, adapte automatiquement votre CV, génère des lettres de motivation IA personnalisées et postule pour vous — tandis que vous suivez tout depuis un tableau de bord.",
    cta_get_started: "Commencer gratuitement",
    cta_see_how: "Voir le fonctionnement",
    trust_line: "Plébiscité par les chercheurs d’emploi, localement et dans le monde entier.",
    dash_preview: "Aperçu du tableau de bord",
    jobs_applied: "Candidatures",
    today: "Aujourd’hui",
    this_week: "Cette semaine",
    bullet_1: "Lettres personnalisées par l’IA",
    bullet_2: "Formulaires auto-remplis",
    bullet_3: "Suivi des résultats",
    bullet_4: "Conformité de la plate-forme",
    footer_privacy: "Confidentialité",
    footer_terms: "Conditions",
    rights: "Tous droits réservés.",
  },

  es: {
    brand: "JOBolar.Ai",
    nav_how: "Cómo funciona",
    nav_features: "Funciones",
    nav_reviews: "Reseñas",
    nav_pricings: "Precios",
    nav_faq: "Preguntas frecuentes",
    nav_contact: "Contacto",
    nav_login: "Iniciar sesión",
    nav_signup: "Regístrate",
    hero_title_prefix: "Postula automáticamente con",
    hero_sub:
      "Conecta tu currículum una vez. JOBolar encuentra puestos a nivel local y mundial, adapta automáticamente tu currículum, genera cartas de presentación con IA personalizadas y postula por ti — mientras rastreas todo en un panel.",
    cta_get_started: "Comenzar gratis",
    cta_see_how: "Ver cómo funciona",
    trust_line: "Confiado por personas que buscan empleo, tanto localmente como en todo el mundo.",
    dash_preview: "Vista previa del panel",
    jobs_applied: "Solicitudes enviadas",
    today: "Hoy",
    this_week: "Esta semana",
    bullet_1: "Cartas personalizadas por IA",
    bullet_2: "Autocompletado de solicitudes",
    bullet_3: "Seguimiento de resultados",
    bullet_4: "Cumplimiento de la plataforma",
    footer_privacy: "Privacidad",
    footer_terms: "Términos",
    rights: "Todos los derechos reservados.",
  },

  de: {
    brand: "JOBolar.Ai",
    nav_how: "Funktionsweise",
    nav_features: "Funktionen",
    nav_reviews: "Bewertungen",
    nav_pricings: "Preise",
    nav_faq: "Häufige Fragen",
    nav_contact: "Kontakt",
    nav_login: "Anmelden",
    nav_signup: "Registrieren",
    hero_title_prefix: "Automatisch bewerben mit",
    hero_sub:
      "Verbinden Sie Ihren Lebenslauf einmal. JOBolar findet Stellen vor Ort und weltweit, passt automatisch Ihren Lebenslauf an, erstellt individuelle KI-Anschreiben und bewirbt sich für Sie – während Sie alles in einem Dashboard verfolgen.",
    cta_get_started: "Kostenlos starten",
    cta_see_how: "Sehen Sie, wie es funktioniert",
    trust_line: "Vertraut von Jobsuchenden vor Ort und weltweit.",
    dash_preview: "Dashboard-Vorschau",
    jobs_applied: "Bewerbungen",
    today: "Heute",
    this_week: "Diese Woche",
    bullet_1: "KI-gestützte Anschreiben",
    bullet_2: "Automatisches Ausfüllen von Bewerbungen",
    bullet_3: "Ergebnisse verfolgen",
    bullet_4: "Plattformkonformität",
    footer_privacy: "Datenschutz",
    footer_terms: "Bedingungen",
    rights: "Alle Rechte vorbehalten.",
  },


};

// Safe getter used across the app; falls back to English
export function getHomeStrings(langCode) {
  if (!langCode) return HOMEPAGE_DICT.en;
  const normalized = String(langCode).toLowerCase();
  return HOMEPAGE_DICT[normalized] || HOMEPAGE_DICT[normalized.split("-")[0]] || HOMEPAGE_DICT.en;
}

export default HOMEPAGE_DICT;
